type Response<T> = T[]

export function useFormatOptions() {
  const formatOptions = <T>(data: Response<T>, key: string) => {
    return data ? data?.map((d: any) => ({ text: d[key], value: d.id })) : []
  }

  return {
    formatOptions,
  }
}
